module.exports = __webpack_public_path__ + "img/account.f748c127.png";